/* cstrap-xem.js — 13/10 muc 25 (sep): ZOOM ANH GALLERY kieu mac dinh Dawn (product-media-modal), PC + mobile, trang SP V2 + DYO + Rally.
   Bam anh chinh (hoac nut phong to .cstrap__zoom) -> lop phu TOAN MAN nen trang, MOI anh san pham xep DOC NOI DUOI, KHONG KHE (gap 0, margin 0), mo ra cuon toi dung anh vua bam.
   PC: anh rong toi da 1000px can giua; mobile: rong 100%. Nut x dinh goc tren phai. Esc / x / nut Back (mobile) = dong, tra trang dung cho cu.
   Danh sach anh = JSON .cstrap__photos (MOI media 1 lan, khong lay cac slide nhan ban cua carousel vo han) -> khong lap anh.
   Chay o pha CAPTURE tren document de chan lightbox cu (cphoto-lb) va lop mobile cu (cgon-xem). Khong dung !important. */
(function () {
  'use strict';
  if (window.__cstrapXem) return; window.__cstrapXem = 1;

  var CSS = '' +
    '.cxz{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000;background:#fff;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;margin:0;padding:0}' +
    '.cxz[hidden]{display:none}' +
    '.cxz__list{display:block;width:100%;max-width:1000px;margin:0 auto;padding:0;line-height:0;font-size:0}' +
    '.cxz__img{display:block;width:100%;height:auto;max-width:100%;margin:0;padding:0;border:0;background:#f4f2ee;-webkit-user-select:none;user-select:none}' +
    '.cxz__x{position:fixed;top:12px;right:12px;z-index:2;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:50%;background:#fff;color:#111;font-size:30px;line-height:44px;text-align:center;cursor:pointer;box-shadow:0 1px 8px rgba(0,0,0,.28);-webkit-appearance:none;appearance:none}' +
    '.cxz__x:focus-visible{outline:2px solid #111;outline-offset:2px}';
  var styleEl = null;
  function css() { if (styleEl) return; styleEl = document.createElement('style'); styleEl.setAttribute('data-cxz', ''); styleEl.textContent = CSS; document.head.appendChild(styleEl); }

  var lop = null, yCu = 0, nutMo = null, daPush = false, tuLichSu = false;

  function photosOf(media) {
    var p = media.querySelector('.cstrap__photos'); var out = [];
    try { out = JSON.parse(p.textContent) || []; } catch (e) { out = []; }
    /* kich thuoc that (de dat ti le truoc khi anh tai: cuon toi dung anh) lay tu slide tuong ung */
    var dim = {};
    [].slice.call(media.querySelectorAll('.cstrap__slide[data-anh]')).forEach(function (s) {
      var k = parseInt(s.getAttribute('data-anh'), 10); if (isNaN(k) || k < 0 || dim[k]) return;
      var im = s.querySelector('img'); if (im) dim[k] = { w: +im.getAttribute('width') || 0, h: +im.getAttribute('height') || 0 };
    });
    var seen = {};
    return out.map(function (o, i) { return { src: o.src, alt: o.alt || '', w: (dim[i] && dim[i].w) || 0, h: (dim[i] && dim[i].h) || 0 }; })
      .filter(function (o) { if (!o.src || seen[o.src]) return false; seen[o.src] = 1; return true; });
  }

  function slideHienTai(track) {
    var tr = track.getBoundingClientRect(), best = null, bo = 0;
    [].slice.call(track.querySelectorAll('.cstrap__slide')).forEach(function (s) {
      var r = s.getBoundingClientRect(); var ov = Math.min(r.right, tr.right) - Math.max(r.left, tr.left);
      if (ov > bo) { bo = ov; best = s; }
    });
    return best;
  }

  function dong(quaLichSu) {
    if (!lop) return;
    lop.parentNode.removeChild(lop); lop = null;
    document.removeEventListener('keydown', phim, true);
    document.body.classList.remove('cphoto-mo');
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = '';
    window.scrollTo(0, yCu);
    if (nutMo && nutMo.focus) { try { nutMo.focus({ preventScroll: true }); } catch (e) {} }
    if (!quaLichSu && daPush) { tuLichSu = true; try { history.back(); } catch (e) {} }
    daPush = false;
  }
  function phim(e) { if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); dong(false); } }

  function mo(media, ds, thu, opener) {
    css(); if (lop) return;
    nutMo = opener || null;
    yCu = window.pageYOffset || document.documentElement.scrollTop || 0;
    var mb = window.innerWidth < 750;
    lop = document.createElement('div'); lop.className = 'cxz'; lop.setAttribute('role', 'dialog'); lop.setAttribute('aria-modal', 'true'); lop.setAttribute('aria-label', 'Product photos');
    var x = document.createElement('button'); x.type = 'button'; x.className = 'cxz__x'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
    var list = document.createElement('div'); list.className = 'cxz__list';
    ds.forEach(function (a, i) {
      var im = document.createElement('img'); im.className = 'cxz__img';
      im.src = String(a.src).replace(/([?&]width=)\d+/, '$1' + (mb ? 1200 : 1600)); im.alt = a.alt; im.decoding = 'async'; im.draggable = false;
      if (a.w && a.h) { im.width = a.w; im.height = a.h; }
      if (Math.abs(i - thu) > 1) im.loading = 'lazy';
      im.setAttribute('data-thu', i); list.appendChild(im);
    });
    lop.appendChild(list); lop.appendChild(x); document.body.appendChild(lop);
    document.body.classList.add('cphoto-mo');
    document.body.style.position = 'fixed'; document.body.style.top = (-yCu) + 'px'; document.body.style.width = '100%';
    try { history.pushState({ cxz: 1 }, ''); daPush = true; } catch (e) { daPush = false; }
    x.addEventListener('click', function () { dong(false); });
    document.addEventListener('keydown', phim, true);
    var dich = list.children[Math.max(0, Math.min(thu, list.children.length - 1))];
    lop.scrollTop = dich ? dich.offsetTop : 0;
    requestAnimationFrame(function () { if (lop && dich) lop.scrollTop = dich.offsetTop; });
    x.focus({ preventScroll: true });
  }

  window.addEventListener('popstate', function () { if (tuLichSu) { tuLichSu = false; return; } if (lop) { daPush = false; dong(true); } });

  document.addEventListener('click', function (e) {
    if (lop || !e.target || !e.target.closest) return;
    var media = e.target.closest('.cstrap__media'); if (!media) return;
    var zb = e.target.closest('.cstrap__zoom');
    var sl = e.target.closest('.cstrap__slide');
    if (!zb && !sl) return;
    if (e.target.closest('a, video, .s2d, [data-2d], .cstrap__nav, .cstrap__thumbs')) return;
    var track = media.querySelector('.cstrap__track'); if (!track) return;
    if (sl && !track.contains(sl)) return;
    if (sl && sl.classList.contains('cstrap__slide--video')) return;
    var ds = photosOf(media); if (!ds.length) return;
    var cur = sl || slideHienTai(track);
    var thu = cur ? parseInt(cur.getAttribute('data-anh'), 10) : 0;
    if (isNaN(thu) || thu < 0) { if (cur && cur.classList.contains('cstrap__slide--video')) return; thu = 0; }
    thu = Math.max(0, Math.min(thu, ds.length - 1));
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    mo(media, ds, thu, zb || null);
  }, true);
})();
